import { useBalance, useBalanceState } from '@/hooks/useBalance';
import { createContext } from 'react';

//暫定放冇save server & local storage, re-login game 就會 del data
export const BalanceContext = createContext({} as useBalanceState);

type ProviderProps = {
    children: JSX.Element;
};

export const BalanceProvider = (props: ProviderProps) => {
    const { children } = props;
    const globalData = useBalance();
    return (
        <BalanceContext.Provider value={globalData}>
            {children}
        </BalanceContext.Provider>
    );
};
